import MainShaftParallelMisalignmentMutations from "./MainShaftParallelMisalignmentMutations";
import MainShaftParallelMisalignmentGetters from "./MainShaftParallelMisalignmentGetters";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import MainShaftParallelMisalignmentActions from "./MainShaftParallelMisalignmentActions";

const { getters } = MainShaftParallelMisalignmentGetters;

const state = {
	status:             FetchStatus.Init,
	successMessage:     "",
	errorMessage:       "",
	operatingRange:     0,
	frequencyChartData: [],
	signalSettingIds:   [],
	orderChartData:     [],
	orderLayout:        {},
	frequencyLayout:    {},
};

const { actions } = MainShaftParallelMisalignmentActions;

const { mutations } = MainShaftParallelMisalignmentMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	getters,
	namespaced,
};
